import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  AdapterConfiguration,
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.seller}adapterEndpointConfigurations`;

export default async function setAdapterConfiguration(
  payload: AdapterConfiguration,
): Promise<BackResponse<AdapterConfiguration> | BackResponseFailure> {
  try {
    const response = await apiCall<BackResponse<AdapterConfiguration>>(
      ENDPOINT,
      {
        method: SUPPORTED_METHODS.PUT,
        json: payload,
      },
    );

    return response;
  } catch (error) {
    return prepareResponseFailure(error);
  }
}
